import { useEffect, useRef } from 'react';

export default function FinalCTA() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 px-5 pb-32 overflow-hidden"
      style={{ backgroundColor: '#060d0a' }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent, rgba(170,255,69,0.3), transparent)' }}
      />

      {/* Radial glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(10,92,68,0.2) 0%, transparent 70%)' }}
      />

      <div className="max-w-2xl mx-auto relative z-10">
        {/* Headline */}
        <div className="reveal opacity-0 mb-5" style={{ transitionDelay: '0ms' }}>
          <h2
            className="font-bebas text-brand-text text-center leading-tight"
            style={{ fontSize: 'clamp(34px, 10vw, 46px)' }}
          >
            What's the worst that can happen?<br />
            <span className="font-dm font-normal text-brand-grey italic" style={{ fontSize: 'clamp(16px, 5vw, 20px)' }}>
              You try free, it doesn't book a job — you pay nothing.
            </span>
          </h2>
        </div>

        {/* Body */}
        <div className="reveal opacity-0 mb-8 text-center" style={{ transitionDelay: '100ms' }}>
          <p className="font-dm text-brand-grey text-base leading-relaxed">
            No risk. Just upside.<br />
            <strong style={{ color: '#F5F5F5' }}>How many jobs are you missing right now?</strong>
          </p>
        </div>

        {/* CTA */}
        <div className="reveal opacity-0 mb-4" style={{ transitionDelay: '200ms' }}>
          <a
            href="https://apex-emerald-ai.com/contact"
            className="whitespace-nowrap block w-full text-center font-dm font-bold rounded-xl cursor-pointer transition-all duration-200 hover:brightness-110 active:scale-95"
            style={{
              backgroundColor: '#AAFF45',
              color: '#080F0C',
              fontSize: '22px',
              padding: '18px 24px',
              minHeight: '60px',
              boxShadow: '0 0 50px rgba(170,255,69,0.5), 0 4px 24px rgba(0,0,0,0.4)',
            }}
          >
            Yes — Set Up My Free AI Agent →
          </a>
        </div>

        {/* Below CTA */}
        <div
          className="reveal opacity-0 text-center"
          style={{ transitionDelay: '280ms' }}
        >
          <p className="font-dm text-brand-grey text-xs">
            Live in 24 hours. Leave your details — we handle the rest.
          </p>
        </div>

        {/* Bottom footer text */}
        <div
          className="reveal opacity-0 mt-12 pt-8 text-center"
          style={{
            transitionDelay: '360ms',
            borderTop: '1px solid rgba(10,92,68,0.2)',
          }}
        >
          <p className="font-bebas text-brand-text tracking-widest text-lg mb-1">
            APEX<span style={{ color: '#AAFF45' }}>EMERALD</span> AI
          </p>
          <p className="font-dm text-brand-grey text-xs">
            AI Voice Agents for Irish Trades · GDPR Compliant · Irish Support
          </p>
        </div>
      </div>
    </section>
  );
}
